import React from 'react'
import { TableContext } from 'Context/Table'
import { useMemo, useEffect, useState, useContext } from 'react'
import { useParams, useLocation, Link } from 'react-router-dom'
import { useAuthStore } from 'Store/Auth'
import { useProjectGanttChartStore } from 'Store/ProjectGanttChart'
import { shallow } from 'zustand/shallow'
import ResourceBadge from './Components/Cells/ResourceBadge'
import { useShippingRequestStore } from 'Store/ShippingRequest'
import { useProjectStore } from 'Store/Project'
import { useMachineStore } from 'Store/Machine'
import { useAppStore } from 'Store/App'

import moment from 'moment'
import { KTSVG } from '../../../../_metronic/helpers'
import clsx from 'clsx'
import { toast } from 'react-toastify'
import CustomActionCell from 'Presentation/Components/Table/Components/CustomActionCell'
import Swal from 'sweetalert2'
import formatDate from '../../../../Utils/formatDate'
import withReactContent from 'sweetalert2-react-content'

const PAGES = [
  {
    label: 'ภาพรวม',
    href: '/project/:id/overview',
    active: false,
  },
  {
    label: 'ข้อมูลเบื้องต้น / วันที่เริ่มงาน',
    href: '/project/:id/info',
    active: false,
  },
  {
    label: 'การขนส่งเสา',
    href: '/project/:id/shipping-request',
    active: false,
  },
  {
    label: 'รายการเสา',
    href: '/project/:id/asset-request',
    active: false,
  },
  {
    label: 'รายงานประจำวัน',
    href: '/project/:id/issue',
    active: false,
  },
  {
    label: 'เครื่องจักร',
    href: '/project/:id/machine',
    active: false,
  },
  {
    label: 'รายชื่อ Site Supervisor',
    href: '/project/:id/site-supervisor',
    active: false,
    permissionRoleIds: [1, 7, 11, 19],
  },
  {
    label: 'รายชื่อผู้ขาย',
    href: '/project/:id/sales',
    active: false,
    permissionRoleIds: [1, 7, 11, 19],
  },
  {
    label: 'บันทึกเหตุการณ์',
    href: '/project/:id/event-log',
    active: false,
  },
]

const MOCK_RESOURCE_AUTHORIZATION_DATA = [
  {
    id: 1,
    name: 'Outsource A',
    type: 'Vendor',
    assigneeDate: '2021-08-01',
  },
  {
    id: 2,
    name: 'ลุงแดงรถตักดิน เจ้าพระยา',
    type: 'Vendor',
    assigneeDate: '2021-08-01',
  },
  {
    id: 3,
    name: 'SCG Home - คุณเต้',
    type: 'Customer',
    assigneeDate: '2021-08-01',
  },
  {
    id: 4,
    name: 'SCG Home - คุณเม',
    type: 'Customer',
    assigneeDate: '2021-08-01',
  },
  {
    id: 5,
    name: 'วิศวกร 1',
    type: 'Employee',
    assigneeDate: '2021-08-01',
  },
  {
    id: 6,
    name: 'วิศวกร 2',
    type: 'Employee',
    assigneeDate: '2021-08-01',
  },
  {
    id: 7,
    name: 'Foreman SCG Home - คุณมิ้นท์',
    type: 'Customer',
    assigneeDate: '2021-08-01',
  },
]
interface StateMachine {
  machineId: number | null
  pillingType: string
  oldMachineId: string
  contractor: string
  externalStreamingEndpoint: string
  actionAt: string | null
  arrivedAt: string | null
  departedAt: string | null
}
const INITAIL_STATE_MACHINE: StateMachine = {
  machineId: null,
  pillingType: '',
  oldMachineId: '',
  contractor: '',
  externalStreamingEndpoint: '',
  actionAt: null,
  arrivedAt: null,
  departedAt: null,
}

const ViewModel = () => {
  const setShowBackButton = useAppStore(state => state.setShowBackButton, shallow)
  const location = useLocation()
  const { profile } = useAuthStore(state => ({ profile: state.profile }), shallow)
  const { page, id } = useParams<{ page: string; id: string }>()
  const { project, tasks, getOne } = useProjectGanttChartStore()
  const { shippingRequests, getAllShippingRequest } = useShippingRequestStore(
    state => ({
      shippingRequests: state.data,
      getAllShippingRequest: state.getAll,
    }),
    shallow
  )
  const {
    projectData,
    piles,
    machines,
    getProject,
    getPiles,
    downloadDailyReport,
    getMachines,
    assignMachine,
    updateMachine,
    deleteMachine,
    clearState,
  } = useProjectStore(
    state => ({
      projectData: state.selected,
      piles: state.piles,
      machines: state.machines,
      getProject: state.getOne,
      getPiles: state.getPiles,
      downloadDailyReport: state.downloadDailyReportByProjetId,
      getMachines: state.getAllProjectMachine,
      assignMachine: state.assignMachineToProject,
      updateMachine: state.updateMachineToProject,
      deleteMachine: state.deleteMachineToProject,
      clearState: state.clearState,
    }),
    shallow
  )
  const { machineData, getMachineData } = useMachineStore(
    state => ({
      machineData: state.data,
      getMachineData: state.getAll,
    }),
    shallow
  )
  const userRoleId = profile?.roleId || 0

  const [isSubmittingAssignMachine, setIsSubmittingAssignMachine] = useState(false)
  const [isOpenAssignMachineModal, setIsOpenAssignMachineModal] = useState(false)
  const [machineFormState, setMachineFormState] = useState(INITAIL_STATE_MACHINE)
  const [machineFormType, setMachineFormType] = useState<'add' | 'edit'>('add')

  const { updateLoading, updatePagination } = useContext(TableContext)

  const [isDownloadDailyReport, setIsDownloadDailyReport] = useState(false)

  const [maintenance] = useState([
    {
      label: 'ฝนตก',
      value: 50,
    },
    {
      label: 'เครื่องจักรเสีย',
      value: 8,
    },
    {
      label: 'รอลูกค้า',
      value: 25,
    },
    {
      label: 'รอสรุปความยาว',
      value: 69,
    },
    {
      label: 'วันหยุด',
      value: 17,
    },
    {
      label: 'ฟื้นฟู',
      value: 70,
    },
    {
      label: 'อุปสรรคใต้ดิน',
      value: 30,
    },
  ])
  const [openAssetRequestModal, setOpenAssetRequestModal] = useState(false)
  const [openResourceAuthorizationModal, setOpenResourceAuthorizationModal] = useState(false)

  const pages = useMemo(
    () =>
      PAGES.reduce((acc: any[], p) => {
        if (p.permissionRoleIds && !p.permissionRoleIds.includes(userRoleId)) {
          return acc
        }

        acc.push({
          ...p,
          active: location.pathname === p.href.replace(':id', id ?? ''),
          href: p.href.replace(':id', id ?? ''),
        })

        return acc
      }, []),
    [id, location.pathname, userRoleId]
  )

  const preprocessedMachineData = useMemo(() => {
    let results = machineData
      .filter(m => {
        if (m?.projectMachine) {
          if (m.projectMachine.projectId === parseInt(id as any)) {
            return false
          }
        }

        return true
      })
      .map(m => ({
        label: `${m.brand ?? ''} ${m.machineModel ?? ''} (${m.machineCode}) - ${
          m.machineType?.title
        }`,
        projectMachine: m.projectMachine,
        value: m.id,
      }))

    if (machineFormType === 'edit') {
      const findedMachine = machineData.find(m => {
        return m.id === machineFormState.oldMachineId
      })

      results.push({
        label: `${findedMachine?.brand ?? ''} ${findedMachine?.machineModel ?? ''} (${
          findedMachine?.machineCode
        }) - ${findedMachine?.machineType?.title}`,
        projectMachine: findedMachine?.projectMachine,
        value: findedMachine?.id,
      })
    }

    return results
  }, [machineData, id, machineFormType, machineFormState.oldMachineId])

  //////////////
  // Overview //
  //////////////

  const fetchProject = async (projectId: string) => {
    try {
      await getOne(projectId)
    } catch (err: any) {
      console.log(err)
    }
  }

  const onDownloadDailyReport = (projectId: string) => {
    setIsDownloadDailyReport(true)
    downloadDailyReport(projectId).then(({ data, success }) => {
      if (!success) {
        toast.error(data)
      }
      setIsDownloadDailyReport(false)
    })
  }

  ///////////////////
  // Asset Request //
  ///////////////////
  const SHIPPING_REQUEST_COLUMN_CONFIGS: any[] = [
    {
      Header: 'No.',
      accessor: 'id',
      width: 50,
      minWidth: 50,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'สถานะ',
      accessor: 'status',
      width: 120,
      minWidth: 120,
      Cell: ({ value }: any) => {
        let badgeColor = ''
        if (value === 'delivering') {
          badgeColor = 'bg-primary'
        } else if (value === 'completed') {
          badgeColor = 'bg-success'
        }

        let displayValue = ''
        if (value === 'pending') {
          displayValue = 'รอส่ง'
        } else if (value === 'delivering') {
          displayValue = 'กำลังส่ง'
        } else if (value === 'completed') {
          displayValue = 'ส่งสำเร็จ'
        }

        return (
          <span
            className={`badge ${badgeColor}`}
            style={{ backgroundColor: value === 'pending' ? '#6c757d' : undefined }}>
            {displayValue}
          </span>
        )
      },
    },
    {
      Header: 'วันที่สร้างคำร้อง',
      accessor: 'createdAt',
      width: 120,
      minWidth: 120,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{moment(value).format('DD/MM/YYYY HH:mm')}</span>
      },
    },

    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <React.Fragment>
          <Link
            to={`/shipping-request/${row.original.id}?saleOrderId=${projectData.saleOrderId}&projectId=${projectData.id}`}>
            <button className='btn btn-icon btn-active-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-2x' />
            </button>
          </Link>
        </React.Fragment>
      ),
    },
  ]
  const ASSET_REQUEST_COLUMN_CONFIGS: any[] = [
    {
      Header: 'ชื่อเสา',
      accessor: 'pileTitle',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => <span className='text-gray-800'>{value}</span>,
    },
    {
      Header: 'Item Code',
      accessor: 'pileCode',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => <span className='text-gray-800'>{value}</span>,
    },
    {
      Header: 'รหัสเสา',
      accessor: 'inventoryCode',
      Cell: ({ value }: any) => <span className='text-gray-800'>{value.split('-')?.[0]}</span>,
    },
    {
      Header: 'รหัสบาร์โค้ด',
      accessor: 'barcode',
      Cell: ({ row }: any) => <span className='text-gray-800'>{row.original.inventoryCode}</span>,
    },
    {
      Header: 'วันที่สแกนรับเสา',
      accessor: 'receivedToProjectAt',
      Cell: ({ value }: any) => (
        <span className='text-gray-800'>
          {value ? moment(value).format('DD/MM/YYYY HH:mm') : '-'}
        </span>
      ),
    },
    {
      Header: 'สถานะการใช้งาน',
      accessor: 'usageStatus',
      width: 120,
      minWidth: 120,
      Cell: ({ value }: any) => {
        let displayValue = ''
        if (value === 'received') {
          displayValue = 'รับเสาแล้ว'
        } else if (value === 'pile-driving') {
          displayValue = 'กำลังตอกเสา'
        } else if (value === 'done') {
          displayValue = 'ใช้งานเสาแล้ว'
        }

        return (
          <div
            className={clsx('badge', {
              'badge-primary': value === 'pile-driving',
              'badge-success': value === 'done',
            })}
            style={{
              backgroundColor: value === 'received' ? '#6c757d' : undefined,
              textTransform: 'capitalize',
            }}>
            {displayValue}
          </div>
        )
      },
    },
    // {
    //   Header: 'จำนวน',
    //   accessor: 'amount',
    //   headerRight: true,
    //   width: 120,
    //   minWidth: 120,
    //   Cell: ({ value }: { value: number }) => <div className='text-end'>{value}</div>,
    // },
    // {
    //   Header: 'หน่วย',
    //   accessor: 'unit',
    //   width: 120,
    //   minWidth: 120,
    // },
  ]

  const handleOpenAssetRequestModal = () => {
    setOpenAssetRequestModal(true)
  }

  const handleCloseAssetRequestModal = () => {
    setOpenAssetRequestModal(false)
  }

  ////////////////////////////////
  // Resource and Authorization //
  ////////////////////////////////

  const RESOURCE_AUTHORIZATION_COLUMN_CONFIGS: any[] = [
    {
      Header: 'เลขที่',
      accessor: 'id',
      width: 100,
      minWidth: 100,
    },
    {
      Header: 'ชื่อ',
      accessor: 'name',
      width: 300,
      minWidth: 300,
    },
    {
      Header: 'ประเภท',
      accessor: 'type',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: { value: string }) => <ResourceBadge value={value} />,
    },
    {
      Header: 'วันที่มอบหมาย',
      accessor: 'assigneeDate',
      width: 200,
      minWidth: 200,
    },
  ]

  const handleOpenResourceAuthorizationModal = () => {
    setOpenResourceAuthorizationModal(true)
  }

  const handleCloseResourceAuthorizationModal = () => {
    setOpenResourceAuthorizationModal(false)
  }

  //////////////
  // Machines //
  //////////////

  const onStartAssignMachine = () => {
    setMachineFormType('add')
    setIsOpenAssignMachineModal(true)
  }

  const onEditMachine = (machineId: string) => {
    const findedMachine = machines.find(m => m.machineId === machineId)

    if (findedMachine) {
      setMachineFormType('edit')
      setMachineFormState({
        ...machineFormState,
        pillingType: findedMachine.pillingType,
        machineId: findedMachine.machineId,
        oldMachineId: findedMachine.machineId,
        contractor: findedMachine.contractor,
        externalStreamingEndpoint: findedMachine.externalStreamingEndpoint,
        actionAt: findedMachine.actionAt
          ? moment(findedMachine.actionAt).format('DD/MM/YYYY')
          : null,
        arrivedAt: findedMachine.arrivedAt
          ? moment(findedMachine.arrivedAt).format('DD/MM/YYYY')
          : null,
        departedAt: findedMachine.departedAt
          ? moment(findedMachine.departedAt).format('DD/MM/YYYY')
          : null,
      })

      setTimeout(() => {
        setIsOpenAssignMachineModal(true)
      }, 100)
    }
  }

  const onDeleteMachine = (machineId: string) => {
    Swal.fire({
      title: 'ลบเครื่องจักร?',
      text: 'คุณต้องการที่จะลบเครื่องจักรออกจากโครงการนี้หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(result => {
      if (result.isConfirmed) {
        deleteMachine(id ?? '0', machineId).then(({ success, data }) => {
          if (!success) {
            toast.error(`ลบเครื่องจักรไม่สำเร็จ: ${data}`)
          } else {
            toast.success('ลบเครื่องจักรสำเร็จ')
            getMachines(id ?? '0')
            getMachineData()
          }
        })
      }
    })
  }

  const MACHINE_TABLE_CONFIGS: any[] = [
    {
      Header: 'วันที่เข้างาน',
      accessor: 'arrivedAt',
      width: 100,
      minWidth: 100,
      Cell: ({ value }: any) => {
        return (
          value && (
            <span className='text-gray-800'>{value ? moment(value).format('DD/MM/YYYY') : ''}</span>
          )
        )
      },
    },
    {
      Header: 'วันที่เริ่มงาน',
      accessor: 'actionAt',
      width: 100,
      minWidth: 100,
      Cell: ({ value }: any) => {
        return (
          value && (
            <span className='text-gray-800'>{value ? moment(value).format('DD/MM/YYYY') : ''}</span>
          )
        )
      },
    },
    {
      Header: 'รหัสเครื่องจักร',
      accessor: 'machineCode',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'ระบบติดตั้ง',
      accessor: 'pillingType',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'ประเภทของเครื่องจักร',
      accessor: 'machineType',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value?.title}</span>
      },
    },
    {
      Header: 'ผู้รับเหมา',
      accessor: 'contractor',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: 'Streaming',
      accessor: 'externalStreamingEndpoint',
      width: 200,
      minWidth: 200,
      Cell: ({ value }: any) => {
        return <span className='text-gray-800'>{value}</span>
      },
    },
    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <CustomActionCell
          id={row.original.machineId}
          hideView
          hideDuplicate
          onClickEdit={() => {
            onEditMachine(row.original.machineId)
          }}
          onClickDelete={() => {
            onDeleteMachine(row.original.machineId)
          }}
        />
      ),
    },
  ]

  const onChangeMachineFormState = (name: string, value: any) => {
    let preFieldPillingType = ''
    if (name === 'machineId') {
      preFieldPillingType = machineData.find(m => m.id === value)?.pillingType || ''
    }

    setMachineFormState(prev => ({
      ...prev,
      [name]: value,
      pillingType:
        name === 'machineId'
          ? preFieldPillingType
          : name === 'pillingType'
          ? value
          : prev.pillingType,
    }))
  }

  const onStopAssignMachine = () => {
    setIsOpenAssignMachineModal(false)

    setTimeout(() => {
      setMachineFormState(INITAIL_STATE_MACHINE)
    }, 200)
  }

  const onSubmitAssignMachine = () => {
    if (id) {
      if (!machineFormState.machineId) {
        toast.error('กรุณาเลือกเครื่องจักร')
      } else {
        setIsSubmittingAssignMachine(true)

        if (machineFormType === 'add') {
          const proceedAssign = () => {
            const inputData = {
              ...machineFormState,
              actionAt: machineFormState.actionAt
                ? moment(machineFormState.actionAt).utc(true).toISOString()
                : null,
              arrivedAt: machineFormState.arrivedAt
                ? moment(machineFormState.arrivedAt).utc(true).toISOString()
                : null,
              departedAt: machineFormState.departedAt
                ? moment(machineFormState.departedAt).utc(true).toISOString()
                : null,
            }
            assignMachine(id, inputData).then(({ success, data }) => {
              if (!success) {
                toast.error(`เพิ่่มเครื่องจักรไม่สำเร็จ: ${data}`)
                setIsSubmittingAssignMachine(false)
              } else {
                setIsSubmittingAssignMachine(false)
                toast.success('เพิ่มเครื่องจักรสำเร็จ')

                getMachines(id)
                getMachineData()

                setTimeout(() => {
                  onStopAssignMachine()
                }, 200)
              }
            })
          }

          const selectedMachine = machineData.find(
            m => m.id === machineFormState.machineId && m.id !== machineFormState.oldMachineId
          )
          if (selectedMachine?.projectMachine) {
            withReactContent(Swal)
              .fire({
                title: 'เครื่องจักรถูกใช้งานในโครงการอื่น',
                html: (
                  <div>
                    โครงการที่ใช้เครื่องจักรนี้:{' '}
                    <div className='fw-bold text-danger'>
                      {selectedMachine?.projectMachine?.division}
                    </div>
                    <br />
                    คุณแน่ใจหรือไม่ว่าต้องการที่จะนำเครื่องจักรนี้มาใช้ในโครงการนี้?
                  </div>
                ),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
              })
              .then(result => {
                if (result.isConfirmed) {
                  proceedAssign()
                } else {
                  setIsSubmittingAssignMachine(false)
                }
              })
          } else {
            proceedAssign()
          }
        } else if (machineFormType === 'edit') {
          const proceedUpdate = () => {
            const inputData = {
              ...machineFormState,
              actionAt: machineFormState.actionAt
                ? moment(machineFormState.actionAt).utc(true).toISOString()
                : null,
              arrivedAt: machineFormState.arrivedAt
                ? moment(machineFormState.arrivedAt).utc(true).toISOString()
                : null,
              departedAt: machineFormState.departedAt
                ? moment(machineFormState.departedAt).utc(true).toISOString()
                : null,
            }
            updateMachine(id, machineFormState.oldMachineId, inputData).then(
              ({ success, data }) => {
                if (!success) {
                  toast.error(`แก้ไขเครื่องจักรไม่สำเร็จ: ${data}`)
                  setIsSubmittingAssignMachine(false)
                } else {
                  setIsSubmittingAssignMachine(false)
                  toast.success('แก้ไขเครื่องจักรสำเร็จ')
                  setMachineFormState(INITAIL_STATE_MACHINE)
                  getMachines(id)
                  getMachineData()

                  setTimeout(() => {
                    onStopAssignMachine()
                  }, 200)
                }
              }
            )
          }

          const selectedMachine = machineData.find(m => m.id === machineFormState.machineId)
          if (
            selectedMachine?.projectMachine &&
            selectedMachine?.projectMachine?.projectId !== parseInt(id as any)
          ) {
            withReactContent(Swal)
              .fire({
                title: 'เครื่องจักรถูกใช้งานในโครงการอื่น',
                html: (
                  <div>
                    โครงการที่ใช้เครื่องจักรนี้:{' '}
                    <div className='fw-bold text-danger'>
                      {selectedMachine?.projectMachine?.division}
                    </div>
                    <br />
                    คุณแน่ใจหรือไม่ว่าต้องการที่จะนำเครื่องจักรนี้มาใช้ในโครงการนี้?
                  </div>
                ),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก',
              })
              .then(result => {
                if (result.isConfirmed) {
                  proceedUpdate()
                } else {
                  setIsSubmittingAssignMachine(false)
                }
              })
          } else {
            proceedUpdate()
          }
        }
      }
    }
  }
  useEffect(() => {
    const action = async () => {
      try {
        if (id) {
          const projectPromise = fetchProject(id)
          const shippingRequestPromise = getAllShippingRequest({ projectId: parseInt(id) })
          const projectDataPromise = getProject(parseInt(id))
          const pilesPromise = getPiles(parseInt(id))
          const machinesPromise = getMachines(id)
          const machineDataPromise = getMachineData()

          // Wait for all promises to resolve
          await Promise.all([
            projectPromise,
            shippingRequestPromise,
            projectDataPromise,
            pilesPromise,
            machinesPromise,
            machineDataPromise,
          ])

          updateLoading(false)
          updatePagination(true)
        }
      } catch (error) {
        // Handle or log the error
        toast.error(`ดึงข้อมูลไม่สำเร็จ โปรดลองใหม่อีกครั้ง`)
        console.error('An error occurred:', error)
      }
    }

    action()

    return () => {
      clearState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    setShowBackButton(true)

    return () => {
      setShowBackButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    id,
    pages,
    // Overview
    isShowOverview: page === 'overview',
    isShowAssetRequest: page === 'asset-request',
    isShowResourceAndAuthorization: page === 'resource-authorization',
    isShowIssue: page === 'issue',
    isShowReport: page === 'report',
    isShowMachine: page === 'machine',
    project, // mock
    projectData,
    tasks,
    maintenance,
    isDownloadDailyReport,
    onDownloadDailyReport,
    // Shipping Request
    shippingRequests,
    SHIPPING_REQUEST_COLUMN_CONFIGS,
    // Asset Request
    ASSET_REQUEST_COLUMN_CONFIGS,
    piles,
    openAssetRequestModal,
    handleOpenAssetRequestModal,
    handleCloseAssetRequestModal,
    // Resource and Authorization
    RESOURCE_AUTHORIZATION_COLUMN_CONFIGS,
    resourceAuthorizationData: MOCK_RESOURCE_AUTHORIZATION_DATA,
    openResourceAuthorizationModal,
    handleOpenResourceAuthorizationModal,
    handleCloseResourceAuthorizationModal,
    // Machine
    machineFormType,
    machineData: preprocessedMachineData,
    machines,
    MACHINE_TABLE_CONFIGS,
    machineFormState,
    isSubmittingAssignMachine,
    isOpenAssignMachineModal,
    onChangeMachineFormState,
    onStartAssignMachine,
    onStopAssignMachine,
    onSubmitAssignMachine,
  }
}

export default ViewModel
